import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import './DueDate.css';
import * as actions from '../Actions';
import { fetchInitialData } from "../../fetchData";
import Right from '../../right/Right';
import FaqsDisclaimer from '../common/FaqsDisclaimer';
import Service from '../../service/Service';

const service = new Service();

class DueDate extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        
        this.state = {
            
            minDuedate: '',
            maxDuedate: '',
            minChilddate: '',
            maxChilddate: '',
            aDays: '',
            conceptionDate: '',
            firstDate: '',
            loggedin: false,
            IsExpected: false

        }
        if (__isBrowser__ && window.__initialData__) {
            initialData = window.__initialData__['initialData'];
            delete window.__initialData__;

        } else {
            if (props.staticContext) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        this.state = {
            initialData: initialData,
            shortMonth: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            objects: [21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35]
        };
    }
    static initialAction(reqUrl, ftk, authData, uId) {

        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var url = global.api_url + "duedate/getduedateuserdetails";
        let body = JSON.stringify({})
        return fetchInitialData(url, JSON.stringify(header), body);
    }
    componentDidMount() {
        console.log("componentDidMount==================>",this.state.initialData);
        if (!(this.props.location.search == "/faqsApp?from=app") && !(this.props.location.search == "/disclaimerApp?from=app") && !(this.props.location.search == "?callAgain=y") && (this.state.initialData) && (this.state.initialData['msg'] == 1 && this.state.initialData['result'].dueFlag)) {
            let JsonData = this.state.initialData['result'];
            if (JsonData.lmpDate) {
                console.log("componentDidMount==================>2",this.state.initialData);
                let fDate = new Date(JsonData.lmpDate.replace(/-/g, '/'));
                this.state.firstDate = fDate.getDate() + "-" + this.state.shortMonth[fDate.getMonth()] + "-" + fDate.getFullYear();
            } else {
                this.state.firstDate = 0
            }
            if (JsonData.avgcycledays) {
                this.state.aDays = JsonData.avgcycledays
            } else {
                this.state.aDays = 0
            }
            if (JsonData.conceptionDate) {
                let cDate = new Date(JsonData.conceptionDate.replace(/-/g, '/'));
                this.state.conceptionDate = cDate.getDate() + "-" + this.state.shortMonth[cDate.getMonth()] + "-" + cDate.getFullYear();
            } else {
                this.state.conceptionDate = 0
            }
            let redirectionUrl = "/tools/pregnancy-due-date-calculator/details/" + this.state.firstDate + "/" + this.state.aDays + "/" + this.state.conceptionDate;
            this.props.history.push(redirectionUrl);
        }
        if (global.userAry['IsExpected'] || global.ftk != '') {
            this.setState({ IsExpected: true, loggedin: true });
            console.log("componentDidMount ====> true ");
        } else {
            this.setState({ IsExpected: false, loggedin: false });
        }
        this.landDueDatePage();

            service.loadImages();
    }
    landDueDatePage() {
        document.getElementById("lmp").checked = true;
        document.getElementById("FirstDateOfLMP").disabled = false;
    }

    onKeyPressDate = (event) => {
        event.returnValue = false;
        if (event.preventDefault) event.preventDefault();
    }
    hoverDate(event){
        if(document.getElementById("lmp").checked && !event.target.value){
            if(event.target.id!="conceptionDate"){
                event.target.nextSibling.style.display="none";
                event.target.type = "date";
                event.target.readOnly = false;
            }
        }else if(document.getElementById("conception").checked && !event.target.value){
            if(event.target.id=="conceptionDate"){
                console.log("event=======>",event.target);
                event.target.nextSibling.style.display="none";
                event.target.type = "date";
                event.target.readOnly = false;
            }
        }
    }
    hoverOutDate(event){
        if(document.getElementById("lmp").checked && !event.target.value){
            event.target.nextSibling.style.display="block";
            event.target.type = "text";
            // event.target.readOnly = false;
        }else  if(document.getElementById("conception").checked && !event.target.value){
            event.target.nextSibling.style.display="block";
            event.target.type = "text";
            // event.target.readOnly = false;
        }
    }
    onFocusDate = (event) => {
        console.log("onFocusDate================>", event);
        if (document.getElementById("lmp").checked) {
            document.querySelector(".tap_here").style.display = "none";
        } else {
            document.querySelector(".tap_here2").style.display = "none";
        }
        var val;
        if (event.target.value && event.target.value != '') {
            val = new Date(event.target.value);
            var y = val.getFullYear();
            var m = val.getMonth() + 1;
            var d = val.getDate();
            m = m > 9 ? m : "0" + m;
            d = d > 9 ? d : "0" + d;
            var finalVal = y + '-' + m + '-' + d;
            event.target.value = finalVal;
        }
        event.target.type = "date";
        event.target.readOnly = false;
        if (event.preventDefault) event.preventDefault();
        event.target.focus();
    }
    onBlurDate = (event) => {
        if (!document.querySelector("#FirstDateOfLMP").value && document.getElementById("lmp").checked) {
            document.querySelector(".tap_here").style.display = "block";
        }
        else if (!document.querySelector("#conceptionDate").value) {
            document.querySelector(".tap_here2").style.display = "block";
        }
        let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        event.target.type = "text";
        event.target.readOnly = true;
        if (event.target.value && event.target.value != '') {
            let date = new Date(event.target.value);
            let day = date.getDate() > 9 ? date.getDate() : "0" + date.getDate();
            event.target.value = day + "-" + months[date.getMonth()] + "-" + date.getFullYear();
        }
    }
    calculateDueDate() {
        var FirstDateOfLMP = document.querySelector("#FirstDateOfLMP").value;
        var avgCycleDays = document.querySelector("#avgCycleDays").value;
        var conceptionDate = document.querySelector("#conceptionDate").value;
        var isLMP = document.getElementById("lmp").checked;
        var isConception = document.getElementById("conception").checked;
        var varified = !1;
        if (isLMP && !isConception) {
            if (FirstDateOfLMP == "" || avgCycleDays == "") {
                varified = !1;
                if (FirstDateOfLMP == "" && avgCycleDays != "") {
                    document.querySelector(".f_date_err").style.display = "block";
                    document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid red"
                        ;
                    document.querySelector(".f_date_err").innerHTML = "Please Select Date";
                } else if (FirstDateOfLMP != "" && avgCycleDays == "") {
                    document.querySelector(".a_cycle_err").style.display = "block";
                    document.querySelector("#avgCycleDays").style.borderBottom = "1px solid red"
                    document.querySelector(".a_cycle_err").innerHTML = "Please Enter Average Length of a cycle";
                } else {
                    document.querySelector(".f_date_err").style.display = "block";
                    document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid red"
                    document.querySelector(".f_date_err").innerHTML = "Please Select Date";
                    document.querySelector(".a_cycle_err").style.display = "block";
                    document.querySelector("#avgCycleDays").style.borderBottom = "1px solid red"
                    document.querySelector(".a_cycle_err").innerHTML = "Please Enter Average Length of a cycle";
                }
            } else {
                varified = !0;
                document.querySelector(".f_date_err").style.display = "none";
                document.querySelector("#FirstDateOfLMP").style.borderBottom = "1px solid #c4c4c4";
                document.querySelector(".f_date_err").innerHTML = "";
                document.querySelector(".a_cycle_err").style.display = "none";
                document.querySelector("#avgCycleDays").style.borderBottom = "1px solid #c4c4c4"
                document.querySelector(".a_cycle_err").innerHTML = "";
                document.querySelector(".tap_here").style.display = "block";
                document.querySelector(".tap_here2").style.display = "block";
            }
            conceptionDate = ""
        } else if (!isLMP && isConception) {
            if (conceptionDate == "") {
                varified = !1;
                document.querySelector(".c_date_err").style.display = "block";
                document.querySelector("#conceptionDate").style.borderBottom = "1px solid red";
                document.querySelector(".c_date_err").innerHTML = "Please Select Date";
            } else {
                varified = !0;
                document.querySelector(".c_date_err").style.display = "none";
                document.querySelector("#conceptionDate").style.borderBottom = "1px solid #c4c4c4";
                document.querySelector(".c_date_err").innerHTML = "";
            }
            FirstDateOfLMP = "";
            avgCycleDays = ""
        }

        if (varified && (!global.ftk || !navigator.onLine)) {
            if (!navigator.onLine) {
                service.showAlert("Please check internet connection!!");
            } else {
                service.showAlert("Login / Register to get Due Date Calculations");
                // var redirectionUrl = global.loginUrl + '?URL=' + "pregnancy-due-date-calculator/details";
                var redirectionUrl = global.loginUrl + '?URL=' + global.currentURL;

                if (FirstDateOfLMP == "") {
                    redirectionUrl = "" + redirectionUrl + "/0"
                } else {
                    redirectionUrl = "" + redirectionUrl + "/" + FirstDateOfLMP
                }
                if (avgCycleDays == "") {
                    redirectionUrl = redirectionUrl + "/0"
                } else {
                    redirectionUrl = redirectionUrl + "/" + avgCycleDays
                }
                if (conceptionDate == "") {
                    redirectionUrl = redirectionUrl + "/0"
                } else {
                    redirectionUrl = redirectionUrl + "/" + conceptionDate
                }
                console.log(redirectionUrl);
                window.location.href = service.getRedirectUrl(redirectionUrl)
                // this.props.history.push(service.getRedirectUrl(redirectionUrl));

            }
        }
        if (varified && global.ftk && navigator.onLine) {
            var redirectionUrl = "/tools/pregnancy-due-date-calculator/details";
            if (FirstDateOfLMP == "") {
                redirectionUrl = "" + redirectionUrl + "/0"
            } else {
                redirectionUrl = "" + redirectionUrl + "/" + FirstDateOfLMP
            }
            if (avgCycleDays == "") {
                redirectionUrl = redirectionUrl + "/0"
            } else {
                redirectionUrl = redirectionUrl + "/" + avgCycleDays
            }
            if (conceptionDate == "") {
                redirectionUrl = redirectionUrl + "/0"
            } else {
                redirectionUrl = redirectionUrl + "/" + conceptionDate
            }
            console.log(redirectionUrl);
            // window.location.href = redirectionUrl;
            this.props.history.push(service.getRedirectUrl(redirectionUrl));
            document.querySelector("#FirstDateOfLMP").value = "";
            document.querySelector("#avgCycleDays").value = "";
            document.querySelector("#conceptionDate").value = "";
            document.querySelector(".tap_here").style.display = "block";
            document.querySelector(".tap_here2").style.display = "block";
        }
    }
    checkForm(id) {
        if (!document.getElementById(id).checked) {
            document.getElementById(id).checked = true;
            document.querySelector("#conceptionDate").value = "";
            if (id == "lmp") {
                document.querySelector("#conceptionDate").value = "";
                document.getElementById("avgCycleDays").disabled = false;
                document.getElementById("FirstDateOfLMP").disabled = false;
                document.querySelector(".tap_here2").style.display = "block";
                document.querySelector(".c_date_err.L10_red").style.display = "none";
                document.querySelector("#conceptionDate").style.borderBottom = "";
                document.getElementById("conceptionDate").disabled = true;
            } else {
                document.querySelector("#FirstDateOfLMP").value = "";
                document.querySelector("#avgCycleDays").value = "";
                document.querySelector(".tap_here").style.display = "block";
                document.querySelector(".f_date_err.L10_red").style.display = "none";
                document.querySelector(".a_cycle_err.L10_red").style.display = "none";

                document.querySelector("#FirstDateOfLMP").style.borderBottom = "";
                document.querySelector("#avgCycleDays").style.borderBottom = "";
                document.getElementById("avgCycleDays").disabled = true;
                document.getElementById("FirstDateOfLMP").disabled = true;
                document.getElementById("conceptionDate").disabled = false;
            }
        }
    }

    render() {
        return (
            <main className="duedate-tool main-container">
                <Helmet
                    title="Pregnancy Due Date Calculator – Figure Out Your Date of Delivery"
                    meta={[
                        { "name": "description", "content": "Excited to know when will your baby arrives? Use our super easy pregnancy due date calculator to calculate your baby’s estimated due date right away!" },
                        { "name": "keywords", "content": "due date calculator, pregnancy due date calculator, baby due date calculator, delivery date calculator, due date calculator week by week" },
                        { "name": "atdlayout", "content": "tools_sp" }
                    ]}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><Link to={service.getRedirectUrl("/")} className="R11_9e">Home</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><Link to={service.getRedirectUrl("/tools")} className="R11_9e">Tools</Link></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span>Due Date Calculator</span>
                    </div>
                    <h1 className="B24_00">Due Date Calculator </h1>
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        <div className="duedatePic">
                            <img className="entry-thumb td-animation-stack-type0-2" src={require("../images/DueDateCalculator-Pic.jpg")} alt="How to calculate delivery date/baby due date calculator" title="How to calculate delivery date/baby due date calculator" />
                            <div className="duedateMsg">
                                <span className="R15_21">Due date is most probable date on which you are likely to give birth to your baby</span>
                            </div>
                        </div>
                        <div className="duedate-block">
                            <div className="duedate-lmp">
                                <label className="duedate-radio-container" onClick={() => { this.checkForm("lmp") }}>
                                    <span className="lmp_method M17_42">LMP Method &nbsp;</span>
                                    <span className="question_icon R15_9e"> [?]</span>
                                    <input id="lmp" type="radio" name="duedate-radio" />
                                    <span className="checkmark"></span>
                                </label>
                                <div className="duedate-method-msg R12_75">
                                    <span className="R13_9e">Recommended</span>
                                </div>
                                <div className="duedate-firstdate">
                                    <label htmlFor="FirstDateOfLMP" className="M17_9e">First Day of Last Period*  </label>
                                    <input id="FirstDateOfLMP" className="rm_inp duedate-datepicker R17_42" type="text" name="FirstDateOfLMP" readOnly onMouseOver={(e)=>this.hoverDate(e)} onMouseOut={(e)=>this.hoverOutDate(e)} onKeyPress={(e) => this.onKeyPressDate(e)} onFocus={(e) => this.onFocusDate(e)} onBlur={(e) => this.onBlurDate(e)} />
                                    <span className="R15_21 tap_here">Tap here to set</span>
                                    <span className="icon calendar-icon" id="calendar-icon" data-icon-font="w"></span>

                                </div>
                                <div className="f_date_err L10_red"></div>
                                <div className="duedate-cycle">
                                    <select id="avgCycleDays" name="avgCycleDays" className="duedate-dropdown">
                                        <option value="" style={{ display: 'none' }} >Average Length of Cycle*</option>
                                        {this.state.objects && this.state.objects.length > 0 && this.state.objects.map((objects, i) =>
                                            <option key={i} value={objects}>{objects}</option>
                                        )}
                                    </select>
                                    <span className="icon arrow-icon" data-icon-font="f"></span>
                                </div>
                                <div className="a_cycle_err L10_red"></div>
                            </div>
                            <div className="duedate-conception">
                                <label className="duedate-radio-container" onClick={() => { this.checkForm("conception") }}>
                                    <span className="lmp_method M17_42">Conception Date Method</span>
                                    <span className="question_icon R15_9e">&nbsp;[?]</span>
                                    <input id="conception" type="radio" name="duedate-radio" />
                                    <span className="checkmark"></span>
                                </label>
                                <div className="R12_75 duedate-method-msg">
                                    <span className="R13_9e">Choose only if you are sure</span>
                                </div>
                                <div className="duedate-firstdate">
                                    <label htmlFor="conceptionDate" className="M17_9e">Date I Conceived *</label>

                                    <input id="conceptionDate" className="rm_inp duedate-datepicker R17_42" type="text" name="conceptionDate" readOnly onMouseOver={(e)=>this.hoverDate(e)} onMouseOut={(e)=>this.hoverOutDate(e)} onKeyPress={(e) => this.onKeyPressDate(e)} onFocus={(e) => this.onFocusDate(e)} onBlur={(e) => this.onBlurDate(e)} disabled />
                                    <span className="R15_21 tap_here2">Tap here to set</span>
                                    <span className="icon calendar-icon" id="calendar-icon2" data-icon-font="w"></span>
                                </div>
                                <div className="c_date_err L10_red"></div>
                            </div>
                            <div id="duedateCalBtn" className="askB_1 calculateDuedate" onClick={() => { this.calculateDueDate() }}>
                                <p title="Calculate  My Due Date" className="clcdue">
                                    <span className="clcdue" >CALCULATE MY DUE DATE</span>
                                </p>
                            </div>
                        </div>
                    <FaqsDisclaimer eleRef={this} />
                    </div>
                </div>
                <Right url={this.props.match.url} />
            </main>
        )
    }
}

export default DueDate;



// WEBPACK FOOTER //
// src/shared/tools/Duedate/DueDate.js